import { combineReducers } from 'redux'
import {
  ICurrentUserState,
  IGlobalMessagingState,
  IShipmentsCountState,
  IShipmentsState,
  IBidsState,
  ILoadBoardPostsState,
  INotificationState,
  INotesState,
  ITagsState,
  IReservedOfferState,
  IReloadsState,
  IMapboxState,
  ICarrierFMCSAState,
} from 'types'
import bidsReducer from 'utils/reducers/bids'
import fmcsaReducer from 'utils/reducers/fmcsa'
import globalMessagingReducer from 'utils/reducers/globalMessaging'
import loadBoardPostsReducer from 'utils/reducers/loadBoardPosts'
import mapboxReducer from 'utils/reducers/mapbox'
import notesReducer from 'utils/reducers/notes'
import notificationReducer from 'utils/reducers/notification'
import reloadsReducer from 'utils/reducers/reloads'
import reservedOfferReducer from 'utils/reducers/reservedOffer'
import shipmentNoteTagsReducer from 'utils/reducers/shipmentNoteTags'
import shipmentsReducer from 'utils/reducers/shipments'
import shipmentsCountReducer from 'utils/reducers/shipmentsCount'
import tagsReducer from 'utils/reducers/tags'
import uiReducer from 'utils/reducers/ui'
import userMetaReducer from 'utils/reducers/user'
import {
  ISidebarState,
  IUIState,
  IFiltersState,
  IOptionsState,
  ICarrierMatchesState,
  ICarrierState,
  ICoverLoadState,
} from 'apps/booking/types'
import { IDriverState } from 'apps/fleet-planner/types/loads'
import driversReducer from 'apps/fleet-planner/utils/reducers/drivers'
import carrierReducer from './carrier'
import carrierMatchesReducer from './carrierMatches'
import coverLoadReducer from './coverLoad'
import filtersReducer from './filters'
import optionsReducer from './options'
import shipmentsStatsReducer from './shipmentsStats'
import sidebarReducer from './sidebar'

export interface IStore {
  mapbox: IMapboxState
  shipments: IShipmentsState
  currentUser: ICurrentUserState
  globalMessaging: IGlobalMessagingState
  sidebar: ISidebarState
  notification: INotificationState
  bids: IBidsState
  shipmentsCount: IShipmentsCountState
  ui: IUIState
  options: IOptionsState
  notes: INotesState
  tags: ITagsState
  shipmentNoteTags: ITagsState
  reservedOffer: IReservedOfferState
  filters: IFiltersState
  reloads: IReloadsState
  loadBoardPosts: ILoadBoardPostsState
  carrierMatches: ICarrierMatchesState
  carrier: ICarrierState
  coverLoad: ICoverLoadState
  drivers: IDriverState
  fmcsa: ICarrierFMCSAState
}

const reducers = combineReducers({
  mapbox: mapboxReducer,
  shipments: shipmentsReducer,
  currentUser: userMetaReducer,
  sidebar: sidebarReducer,
  notification: notificationReducer,
  bids: bidsReducer,
  shipmentsCount: shipmentsCountReducer,
  shipmentsStats: shipmentsStatsReducer,
  ui: uiReducer,
  options: optionsReducer,
  notes: notesReducer,
  tags: tagsReducer,
  shipmentNoteTags: shipmentNoteTagsReducer,
  reservedOffer: reservedOfferReducer,
  filters: filtersReducer,
  reloads: reloadsReducer,
  loadBoardPosts: loadBoardPostsReducer,
  carrier: carrierReducer,
  coverLoad: coverLoadReducer,
  fmcsa: fmcsaReducer,
  carrierMatches: carrierMatchesReducer,
  drivers: driversReducer,
  globalMessaging: globalMessagingReducer,
})

export default reducers
